import { InstructionCard } from 'components/global/InstructionCard/InstructionCard';
import { useNavigate, useParams } from 'react-router-dom';
import Styles from './InstructionsView.module.scss';
import { useState } from 'react';
import { useEffect } from 'react';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

export function InstructionsView({ data, loading, instructionsRef, ...props }) {

    const [nodeInfo, setNodeInfo] = useState('');
    const [isloading, setIsloading] = useState(false);

    useEffect(() => {
        if (data) {
            setNodeInfo(data);
        }
    }, [data]);

    const ID = useParams();

    const navigate = useNavigate();
    const handleStartClick = () => {
        navigate(`/labs/${ID.lab_id}/nodes/${ID.node_id}/${nodeInfo.resource}`);
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <>
            <LoadingBackdrop isOpen={isloading} />
            {loading ? (
                <div>
                    <LoadingBackdrop isOpen={true} />
                </div>
            ) : nodeInfo ? (
                <>
                    <div className={Styles.CardContainer} ref={instructionsRef}>
                        <InstructionCard
                            instructions={nodeInfo.instructions_list}
                            handleStartClick={() => {
                                setIsloading(true);
                                handleStartClick();
                            }}
                            handleBackClick={handleBackClick}
                        />
                    </div>
                </>
            ) : (
                <>
                    {props.t('Labs.InfoForNodes.instructions.none')}
                </>
            )}
        </>
    );
}
